<template>
  <div class="custom-select white-bg">
    <el-form>
      <el-row
        :gutter="20"
        class="page-query-content">
        <el-col
          :xs="24" :sm="12" :md="8" :lg="8">
          <el-form-item
            label="类型"
          >
            <el-select
              v-model="type"
              clearable
              placeholder="请选择"
              class="vsselect"
              @change="toQuery"
            >
              <el-option
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="8">
          <el-form-item
            label="实名状态"
          >
            <el-select
              v-model="idStatus"
              clearable
              placeholder="请选择"
              class="vsselect"
              @change="toQuery"
            >
              <el-option
                v-for="(item,index) in idStatusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="8">
          <el-form-item
            label="创建时间"
          >
            <el-date-picker
              type="daterange"
              v-model="duratiem"
              clearable
              placeholder="请选择"
              class="vsselect"
              @change="toQuery"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import  selectQuery from '@/mixins/selectQuery'
  export default {
    name: "querySelect",
    data() {
      return {
        type: '',
        typeList: [
          {
            label: '商户',
            value: 1
          },
          {
            label: '个人',
            value: 2
          },
        ],
        idStatus: '',
          idStatusList:[
            {
              label: '未认证',
              value: 0
            },
            {
              label: '待审核',
              value: 1
            },
            {
              label: '审核拒绝',
              value: 2
            },
            {
              label: '审核通过',
              value: 3
            },
          ],
        duratiem: ''
      }
    },
    mixins: [selectQuery],
  }
</script>

<style lang="scss" scoped>
  .custom-select {
    margin-bottom: 20px;
  }
  .vsselect {
    width: 100%;
    margin-bottom: 10px;
  }
</style>
